import Style from "./css/style.module.css";
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios/index";
import strFunc from '@/lib/lyg/string';

function PayByDetPopup(props: any) {
  let myProps = {
    select_order_det_arr: [],
    closePopup: () => { },
    refreshData: (inData: any) => { },
    callbackData: (inData: any) => { },
    ...props
  };
  let user = useSelector((state: any) => state.user);
  const [mcomp_point, set_mcomp_point] = useState<any>(0);
  const [corp_info, set_corp_info] = useState<any>({
    a_response_tel: "",
  });
  const [select_order_det_arr, set_select_order_det_arr] = useState<any>(myProps.select_order_det_arr);
  const [is_deliver_cost, set_is_deliver_cost] = useState<any>(false);
  const [is_shop_order_payt_parent, set_opt_is_shop_order_payt_parent] = useState<any>(false);
  const [stu_arr, set_stu_arr] = useState<any>([]);
  const [select_payt_receiver, set_select_payt_receiver] = useState<any>({
    phone_num: "",
    user_name: "",
  });

  let order_det_cost_sum = 0;
  let checked_cost = 0;
  for (let i = 0; i < select_order_det_arr.length; i++) {
    let order_det = select_order_det_arr[i];
    order_det_cost_sum += parseInt(strFunc.uncomma(order_det.a_price));
    order_det_cost_sum += parseInt(strFunc.uncomma(order_det.a_price_tax));
  }
  checked_cost = order_det_cost_sum;
  if (is_deliver_cost) {
    checked_cost += 4000;
  }

  let tmp_payt_phone_num_arr: any = [];
  let parent_link_user_arr: any = [];
  if (is_shop_order_payt_parent) {
    for (let i = 0; i < stu_arr.length; i++) {
      let tmp_stu_info = stu_arr[i];
      if (tmp_stu_info.link_user_arr && tmp_stu_info.link_user_arr.length > 0) {
        for (let p_i = 0; p_i < tmp_stu_info.link_user_arr.length; p_i++) {
          let tmp_link_user = tmp_stu_info.link_user_arr[p_i];
          tmp_link_user.a_stu_name = tmp_stu_info.a_user_name;

          if (tmp_link_user.par_info && tmp_link_user.par_info.a_user_phone) {
            if (strFunc.str_in_array(tmp_link_user.par_info.a_user_phone, tmp_payt_phone_num_arr) == -1) {
              tmp_payt_phone_num_arr.push(tmp_link_user.par_info.a_user_phone);
              parent_link_user_arr.push(tmp_link_user);
            }
          }
        }
      }
    }
  }

  useEffect(() => {
    getPointNumByAjax();
    get_corp_info_by_ajax();
    //set_deliver_cost_by_order_det_arr({ order_det_arr: select_order_det_arr });
  }, [user]);

  useEffect(() => {
    get_stu_arr_by_ajax({
      select_order_det_arr: select_order_det_arr
    });
  }, [select_order_det_arr]);

  useEffect(() => {
    if (is_shop_order_payt_parent) {
      let payt_phone_num = "";
      let payt_user_name = "";
      for (let i = 0; i < stu_arr.length; i++) {
        let tmp_stu_info = stu_arr[i];
        if (tmp_stu_info.link_user_arr && tmp_stu_info.link_user_arr.length > 0) {
          let tmp_par_link = tmp_stu_info.link_user_arr[0];
          if (tmp_par_link.par_info && tmp_par_link.par_info.a_user_phone) {
            payt_phone_num = tmp_par_link.par_info.a_user_phone;
            payt_user_name = tmp_stu_info.a_user_name + " 보호자";
          }
        }
      }
      set_select_payt_receiver({
        phone_num: payt_phone_num,
        user_name: payt_user_name,
      });
    } else {
      set_select_payt_receiver({
        phone_num: corp_info.a_response_tel,
        user_name: user.user_name,
      });
    }

  }, [is_shop_order_payt_parent,stu_arr]);

  const set_deliver_cost_by_order_det_arr = (inData: any) => {
    let opt_obj = {
      order_det_arr: [],
      ...inData
    };

    let is_exist_mtextbook = false;
    let is_deliver_cost_tmp = false;
    let total_deliver_cost = 0;
    for (let i = 0; i < opt_obj.order_det_arr.length; i++) {
      let order_det = opt_obj.order_det_arr[i];
      if (order_det.a_product_type == "mtextbook") {
        is_exist_mtextbook = true;
        total_deliver_cost += strFunc.uncomma_int(order_det.a_price_sum);
      }
    }
    if (total_deliver_cost < 100000 && is_exist_mtextbook) {
      is_deliver_cost_tmp = true;
    }
    set_is_deliver_cost(is_deliver_cost_tmp);
  };

  const get_stu_arr_by_ajax = (inData: any) => {
    let opt_obj = {
      select_order_det_arr: select_order_det_arr,
      ...inData
    };

    let s_stu_seq_arr: any = [];
    for (let i = 0; i < opt_obj.select_order_det_arr.length; i++) {
      let row_det_info = opt_obj.select_order_det_arr[i];
      if (row_det_info.a_buy_user_seq) {
        if (strFunc.str_in_array(row_det_info.a_buy_user_seq, s_stu_seq_arr) == -1) {
          s_stu_seq_arr.push(row_det_info.a_buy_user_seq);
        }
      }
    }
    if (s_stu_seq_arr.length == 0) {
      return false;
    }
    let form_json_data: any = {
      "s_seq": s_stu_seq_arr,
      "s_addon_link_user": "1",
      "s_addon_link_user_s_order_sort": "supply_sms",
      "is_paging": "",
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/basic/user/user/list', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          set_stu_arr(response.data["data"]["info_arr"]);
        } else {

        }
      });
  };

  const getPointNumByAjax = () => {
    if (strFunc.is_empty(user.comp_seq)) {
      return false;
    }
    let point_form_json = {
      "s_seq": [user.comp_seq],
      "is_addon_point_tot": "1",
      "is_paging": "",
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/main/mcomp/mcomp/list', point_form_json, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          if (response.data["data"]["info_arr"].length > 0) {
            let corp_info = response.data["data"]["info_arr"][0];
            if (corp_info.point_tot_info) {
              set_mcomp_point(corp_info.point_tot_info.tot);
            }
          }
        } else {

        }
      });
  };

  const get_corp_info_by_ajax = () => {
    if (strFunc.is_empty(user.comp_seq)) {
      return false;
    }
    if (strFunc.is_empty(user.corp_seq)) {
      return false;
    }
    let formJsonData = {
      "s_seq": [user.corp_seq],
      s_addon_opt_data: "1",
      "is_paging": "",
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/basic/corp/corp/list', formJsonData, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          if (response.data["data"]["info_arr"].length > 0) {
            let row_corp_info = response.data["data"]["info_arr"][0];
            if (row_corp_info && row_corp_info.opt_data_info
              && row_corp_info.opt_data_info.a_is_shop_order_payt_parent == "1"
            ) {
              set_opt_is_shop_order_payt_parent(true);
            } else {
              set_opt_is_shop_order_payt_parent(false);
            }
            set_corp_info(row_corp_info);
            set_select_payt_receiver({
              phone_num: row_corp_info.a_response_tel,
              user_name: "관리자",
            });
          }
        }
      });
  };

  const callback_select_pay_sort = (inData: any) => {
    let opt_obj = {
      select_order_det_arr: select_order_det_arr,
      pay_sort: "point",//point,payt
      ...inData
    };

    myProps.callbackData(opt_obj);
    myProps.closePopup();
  };

  const go_pay_by_det_by_ajax = (inData: any) => {
    let opt_obj = {
      select_order_det_arr: select_order_det_arr,
      pay_sort: "point",//point,payt
      ...inData
    };

    if (opt_obj.select_order_det_arr.length == 0) {
      alert("결제할 상품이 없습니다.");
      return false;
    }
    if (opt_obj.pay_sort != "point" && opt_obj.pay_sort != "payt") {
      alert("결제수단이 올바르지 않습니다.");
      return false;
    }

    if (is_shop_order_payt_parent) {
      if (stu_arr.length >= 2) {
        alert("학생은 1명만 선택해 주세요.");
        return false;
      }
    }

    if (opt_obj.pay_sort == "payt") {
      if (strFunc.is_empty(checked_cost)) {
        alert("결제금액이 올바르지 않습니다.");
        return false;
      }
      if (is_shop_order_payt_parent) {
        if (strFunc.is_empty(select_payt_receiver.phone_num)) {
          alert("학원핸드폰 번호 입력이 필요합니다.(설정>학원정보)");
          return false;
        }
      } else {
        if (strFunc.is_empty(select_payt_receiver.phone_num)) {
          alert("결제링크 연결할 전화번호가 올바르지 않습니다.");
          return false;
        }
      }
    }
    if (opt_obj.pay_sort == "point") {
      if (mcomp_point < checked_cost) {
        alert("포인트가 부족합니다.");
        return false;
      }
    }

    if (!confirm("선택한 상품을 " + (opt_obj.pay_sort == "point" ? "포인트로" : "결제링크로") + " 결제하시겠습니까?")) {
      return false;
    }

    let order_det_pri_val_arr: any = [];
    for (let i = 0; i < select_order_det_arr.length; i++) {
      let order_det = select_order_det_arr[i];
      let row_pri_val = order_det["a_ymd"] + "," + order_det["a_seq"];
      order_det_pri_val_arr.push(row_pri_val);
    }

    let form_json_data = {
      mcomp_seq: user.comp_seq,
      order_det_seq_arr: order_det_pri_val_arr,
      pay_sort: opt_obj.pay_sort,
      receiv_phone_num: select_payt_receiver.phone_num,
      receiver: select_payt_receiver.user_name,
      is_deliver_cost: is_deliver_cost ? "1" : "",
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/main/shop/shop_order/pay_by_det', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          if (opt_obj.pay_sort == "point") {
            alert("결제가 완료되었습니다.");
          } else if (opt_obj.pay_sort == "payt") {
            alert("결제링크로 결제해주시기 바랍니다.");
          }
          myProps.refreshData({});
          myProps.closePopup();
        } else {
          alert(response.data["msg"]);
        }
      });
  };

  const remove_select_order_det = (inData: any) => {
    let opt_obj = {
      pri_val: "",
      ...inData
    };
    let new_select_order_det_arr = [];
    for (let i = 0; i < select_order_det_arr.length; i++) {
      let order_det = select_order_det_arr[i];
      let tmp_pri_val = order_det["a_ymd"] + "," + order_det["a_seq"];
      if (tmp_pri_val != opt_obj.pri_val) {
        new_select_order_det_arr.push(order_det);
      }
    }
    //set_deliver_cost_by_order_det_arr({ order_det_arr: new_select_order_det_arr });
    set_select_order_det_arr(new_select_order_det_arr);
  };

  const get_select_order_det_tags = () => {
    let tags: any = select_order_det_arr.map((order_det: any, idx: number) => {
      return (
        <div key={idx} className={Style.order_item}>
          <div className={Style.order_info}>
            <span className={Style.product_name}>{order_det.a_product_name}</span>
            <span className={Style.product_quantity}>x{order_det.a_amount}</span>
          </div>
          <div className={Style.order_actions}>
            <span className={Style.product_price}>{strFunc.comma(order_det.a_price_sum)}원</span>
            <button
              className={Style.remove_button}
              onClick={() => {
                remove_select_order_det({
                  pri_val: order_det["a_ymd"] + "," + order_det["a_seq"]
                });
              }}
            >
              ✕
            </button>
          </div>
        </div>
      );
    });
    return tags;
  };
  console.log(parent_link_user_arr);

  return (
    <div className={Style.popup_container}>
      <div className={Style.popup_header}>
        <h2 className={Style.title}>결제 옵션 선택</h2>
      </div>

      <div className={Style.order_list}>
        <h3 className={Style.section_title}>선택한 상품</h3>
        {get_select_order_det_tags()}
      </div>

      {is_deliver_cost &&
        <div>
          <div className={Style.subtotal_section}>
            <span className={Style.subtotal_label}>합계 ({select_order_det_arr.length}건)</span>
            <span className={Style.subtotal_amount}>{strFunc.comma(order_det_cost_sum)}원</span>
          </div>
          <div className={Style.deliver_cost_section}>
            <span className={Style.deliver_cost_label}>배송비</span>
            <span className={Style.deliver_cost_amount}>4,000원</span>
          </div>
          <span className={Style.deliver_cost_note}>
            교재주문 10만원 미만이면 배송비 4,000원이 추가됩니다.
          </span>
        </div>
      }

      <div className={Style.total_section}>
        <span className={Style.total_label}>총 결제금액</span>
        <span className={Style.total_amount}>{strFunc.comma(checked_cost)}원</span>
      </div>

      <div className={Style.popup_content}>
        <h3 className={Style.section_title}>결제 방법</h3>
        <div className={Style.payment_options}>
          <button
            className={`${Style.payment_button} ${Style.point_button}`}
            onClick={() => { go_pay_by_det_by_ajax({}); }}
          >
            <span className={Style.payment_icon}>💰</span>
            <div className={Style.payment_text}>
              <span className={Style.payment_label}>포인트로 결제</span>
              <span className={Style.point_balance}>보유 포인트: {strFunc.comma(mcomp_point)}P</span>
            </div>
          </button>
          <button
            className={`${Style.payment_button} ${Style.card_button}`}
            onClick={() => { go_pay_by_det_by_ajax({ pay_sort: "payt" }); }}
          >
            <span className={Style.payment_icon}>💳</span>
            <div className={Style.payment_text}>
              <span className={Style.payment_label}>결제링크 연결</span>
              <span className={Style.point_balance}>
                HP : {select_payt_receiver.phone_num}
                <span className="ml-1">
                  ({select_payt_receiver.user_name} 님)
                </span>
              </span>
            </div>
          </button>
          <div>
            결제대상
          </div>
          <div className="my_flex_center">
            {(is_shop_order_payt_parent && stu_arr.length >= 2) &&
              <span className="text-red-500 mr-2">
                학생은 1명만 선택해 주세요.
              </span>
            }
            <button className={"btn-l btn-" + (is_shop_order_payt_parent ? "dark" : "blue")}
              onClick={() => {
                set_opt_is_shop_order_payt_parent(false);
              }}
            >학원장</button>
            <button className={"btn-l btn-" + (is_shop_order_payt_parent ? "blue" : "dark")}
              onClick={() => {
                set_opt_is_shop_order_payt_parent(true);
              }}
            >학부모</button>
          </div>
          <div className="text-center mt-1">
            {(is_shop_order_payt_parent && parent_link_user_arr.length > 0) &&
              <select className="search-input"
                name="select_parent_phone_num"
                value={select_payt_receiver.phone_num}
                onChange={(e: any) => {
                  let tmp_select_phone_num = e.target.value;
                  let tmp_user_name = "";
                  for (let i = 0; i < parent_link_user_arr.length; i++) {
                    if (parent_link_user_arr[i].par_info) {
                      if (e.target.value == parent_link_user_arr[i].par_info.a_user_phone) {
                        tmp_user_name = parent_link_user_arr[i].a_stu_name + " 보호자";
                      }
                    }
                  }
                  set_select_payt_receiver({
                    phone_num: tmp_select_phone_num,
                    user_name: tmp_user_name,
                  });
                }}
              >
                <option value="">없음.</option>
                {parent_link_user_arr.map((p_item: any, p_idx: number) => {
                  let tmp_phone_num = "";
                  if (p_item.par_info) {
                    tmp_phone_num = p_item.par_info.a_user_phone;
                    p_item.a_user_name=p_item.par_info.a_user_name;
                  }
                  return (
                    <option key={p_idx} value={tmp_phone_num} >
                      {tmp_phone_num} {p_item.a_user_name}
                    </option>
                  );
                })}
              </select>
            }
          </div>
        </div>
      </div>

      <div className={Style.popup_footer}>
        <button
          className={Style.close_button}
          onClick={() => { myProps.closePopup(); }}
        >
          닫기
        </button>
      </div>
    </div>
  );
};
export default PayByDetPopup;